import { EntityType } from '../../__generated__/graphql'

type EntityColors = Record<EntityType, { backgroundColor: string; color: string }>

const adGroupColors: EntityColors[EntityType.AdGroup] = {
  color: '#505050',
  backgroundColor: '#ffb867',
}

const positionColors: EntityColors[EntityType.Position] = {
  color: '#white',
  backgroundColor: '#ada9da',
}

export const activityFeedConf: Partial<EntityColors> = {
  [EntityType.AdCopy]: {
    color: '#505050',
    backgroundColor: '#ffda6c',
  },
  [EntityType.AdGroup]: adGroupColors,
  [EntityType.AdGroupBudgetPlan]: adGroupColors,
  [EntityType.AdTemplate]: positionColors,
  [EntityType.AdTemplateBanner]: positionColors,
  [EntityType.AdTemplateNative]: positionColors,
  [EntityType.AdTemplateWeb]: positionColors,
  [EntityType.AdTemplateImage]: positionColors,
  [EntityType.BillingContact]: {
    color: '#505050',
    backgroundColor: '#',
  },
  [EntityType.Campaign]: {
    color: '#white',
    backgroundColor: '#ff8e76',
  },
  [EntityType.Company]: {
    color: '#white',
    backgroundColor: '#',
  },
  [EntityType.Position]: positionColors,
  [EntityType.Segment]: {
    color: '#white',
    backgroundColor: '#6fc88a',
  },
  [EntityType.User]: {
    color: '#white',
    backgroundColor: '#',
  },
  [EntityType.Website]: {
    color: '#white',
    backgroundColor: '#cdaada',
  },
  [EntityType.WebsiteDomainExclusion]: {
    color: '#white',
    backgroundColor: '',
  },
  [EntityType.WebsiteIabExclusion]: {
    color: '#white',
    backgroundColor: '',
  },
  [EntityType.AdgroupDirectory]: {
    color: '#505050',
    backgroundColor: '#f7f7f7',
  },
  [EntityType.AdGroupDirectoryPreset]: adGroupColors,
  [EntityType.Advertiser]: {
    color: '#505050',
    backgroundColor: '#ffc9bd',
  },
  [EntityType.User]: {
    color: 'white',
    backgroundColor: '#89abc5',
  },
  [EntityType.Publisher]: {
    color: 'white',
    backgroundColor: '#9465a9',
  },
  [EntityType.Reseller]: {
    color: 'white',
    backgroundColor: '#c5c3e5',
  },
  [EntityType.ProgrammaticCampaign]: {
    color: '#505050',
    backgroundColor: '#adef79',
  },
  [EntityType.Agency]: {
    color: 'white',
    backgroundColor: '#c06095',
  },
  [EntityType.AdGroupTargeting]: {
    color: '#505050',
    backgroundColor: '#f7f7f7',
  },
}
